// Service Types service
import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  serverTimestamp, 
  db 
} from '../../utils/database/firebase-config';

// Default service types
const DEFAULT_SERVICE_TYPES = [
  { value: 'dry', name: { en: 'Dry', ar: 'جاف' }, color: 'blue', isDefault: true },
  { value: 'chilled', name: { en: 'Chilled', ar: 'مبرد' }, color: 'cyan', isDefault: true },
  { value: 'frozen', name: { en: 'Frozen', ar: 'مجمد' }, color: 'blue', isDefault: true },
  { value: 'frozen_chilled', name: { en: 'Frozen/Chilled', ar: 'مجمد/مبرد' }, color: 'cyan', isDefault: true },
  { value: 'chilled_dry', name: { en: 'Chilled/Dry', ar: 'مبرد/جاف' }, color: 'blue', isDefault: true }
];

export const serviceTypesService = {
  async getServiceTypes(companyId) {
    try {
      const serviceTypesRef = collection(db, 'serviceTypes');
      const q = query(serviceTypesRef, where('companyId', '==', companyId));
      const snapshot = await getDocs(q);
      const customTypes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      // Combine default types with custom types
      const allTypes = [
        ...DEFAULT_SERVICE_TYPES.map(type => ({ ...type, isDefault: true })),
        ...customTypes
      ];
      
      return allTypes;
    } catch (error) {
      console.error('Error loading service types:', error);
      // Return default types if there's an error
      return DEFAULT_SERVICE_TYPES.map(type => ({ ...type, isDefault: true }));
    }
  },

  async addServiceType(serviceTypeData) {
    const serviceTypesRef = collection(db, 'serviceTypes');
    const docRef = await addDoc(serviceTypesRef, { 
      ...serviceTypeData, 
      createdAt: serverTimestamp(), 
      updatedAt: serverTimestamp() 
    });
    return docRef.id;
  },

  async updateServiceType(serviceTypeId, serviceTypeData) {
    const serviceTypeRef = doc(db, 'serviceTypes', serviceTypeId);
    await updateDoc(serviceTypeRef, { 
      ...serviceTypeData, 
      updatedAt: serverTimestamp() 
    });
    return true;
  },

  async deleteServiceType(serviceTypeId) {
    const serviceTypeRef = doc(db, 'serviceTypes', serviceTypeId);
    await deleteDoc(serviceTypeRef);
    return true;
  },

  // Delete default service type (converts to custom first, then deletes)
  async deleteDefaultServiceType(serviceTypeValue, companyId) {
    // First save as custom type if it doesn't exist
    const defaultType = DEFAULT_SERVICE_TYPES.find(type => type.value === serviceTypeValue);
    if (!defaultType) {
      throw new Error('Default service type not found');
    }

    // Check if custom version already exists
    const serviceTypesRef = collection(db, 'serviceTypes');
    const q = query(serviceTypesRef, where('companyId', '==', companyId), where('value', '==', serviceTypeValue));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      // Create custom version first
      await this.saveDefaultAsCustom(defaultType, companyId);
    }
    
    // Now delete the custom version
    const customDoc = snapshot.docs[0];
    if (customDoc) {
      await deleteDoc(customDoc.ref);
    }
    
    return true;
  },

  // Save default service type as custom type (for editing)
  async saveDefaultAsCustom(defaultType, companyId) {
    const serviceTypeData = {
      name: defaultType.name,
      value: defaultType.value,
      color: defaultType.color,
      companyId: companyId,
      wasDefault: true
    };
    
    const serviceTypesRef = collection(db, 'serviceTypes');
    const docRef = await addDoc(serviceTypesRef, { 
      ...serviceTypeData, 
      createdAt: serverTimestamp(), 
      updatedAt: serverTimestamp() 
    });
    return docRef.id;
  }
}; 